<template>
	<div class="login-user">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ title }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="login-main">
			<div class="exchange-number">
				<div class="left-title">{{ $t("login.order_password") }}</div>
				<van-cell-group inset style="margin: 0; width: 90%">
					<van-field v-model="oldPassword" :maxlength="maxlength" type="password" :placeholder="tips1" />
				</van-cell-group>
			</div>
			<div class="exchange-number" v-if="$route.query.type == 'login'">
				<div class="left-title">{{ $t("login.new_pwd") }}</div>
				<van-cell-group inset style="margin: 0; width: 90%">
					<van-field v-model="newPassword" :maxlength="maxlength" type="password" :placeholder="tips2" />
				</van-cell-group>
			</div>
			<div class="exchange-number" v-else>
				<div class="left-title">{{ $t("login.new_pwd") }}</div>
				<van-cell-group inset style="margin: 0; width: 90%">
					<van-field v-model="payPassword" :maxlength="maxlength" type="password" :placeholder="tips3" />
				</van-cell-group>
			</div>
			<div class="exchange-number">
				<div class="left-title">{{ $t("login.confirmPassword") }}</div>
				<van-cell-group inset style="margin: 0; width: 90%">
					<van-field v-model="confirmPassword" :maxlength="maxlength" type="password" :placeholder="tips4" />
				</van-cell-group>
			</div>
			<div class="nowLogin" @click="login">
				<div>
					<p>{{ $t("login.confirm") }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { editLoginPwd, payPwd } from "@/utils/request";
export default {
	data() {
		return {
			title: '',
			oldPassword: '',
			payPassword: '',
			newPassword: '',
			confirmPassword: '',
			maxlength: '',
			tips1: this.$t("login.input_ordpwd"),//请输入旧密码
			tips2: this.$t("login.number"),//请设置6-16位大小写字母+数字
			tips3: this.$t("login.six_pwd"),//请输入6位数字密码
			tips4: this.$t("login.confirmPassword"),//确认密码
		};
	},
	mounted() {
		if (this.$route.query.type == 'pay') {
			this.title = this.$t("head.update_assets_password")
			this.maxlength = 6
		}
		if (this.$route.query.type == 'login') {
			this.title = this.$t("head.update_login_password")
			this.maxlength = 16
		}
	},
	methods: {
		login() {
			let _this = this
			if (this.$route.query.type == 'pay') {
				if (_this.payPassword.length != '6' || !Number(_this.payPassword)) {
					_this.$toast(this.$t("login.six_pwd"));
				} else if (_this.payPassword != _this.confirmPassword) {
					_this.$toast(this.$t("prompt.two"));
				} else {
					payPwd({
						oldPassword: _this.oldPassword,
						password: _this.payPassword,
						confirmPassword: _this.confirmPassword,
					}).then((res) => {
						if (res.code == "200") {
							_this.$toast.success(this.$t("prompt.update_success"));
							setTimeout(() => {
								this.$router.go("-1");
							}, 500);
						} else {
							_this.$toast.success(res.msg);
						}
					});
				}
			}
			if (this.$route.query.type == 'login') {
				let reg2 =
					/^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/;
				if (!reg2.test(_this.newPassword)) {
					_this.$toast(this.$t("register.password"));
				} else if (_this.newPassword != _this.confirmPassword) {
					_this.$toast(this.$t("prompt.two"));
				} else {
					editLoginPwd({
						oldPassword: _this.oldPassword,
						password: _this.newPassword,
						confirmPassword: _this.confirmPassword,
					}).then((res) => {
						if (res.code == "200") {
							_this.$toast.success(this.$t("prompt.update_success"));
							setTimeout(() => {
								this.$router.push("/");
							}, 500);
						} else {
							_this.$toast.success(res.msg);
						}
					});

				}

			}

		},
		toBack() {
			this.$router.go("-1");
		},
	},
};
</script>

<style lang="scss" scoped>
.login-user {
	width: 100vw;
	height: 100vh;
	background: #0c0b0b;

	.login-main {
		padding: 0 0.9375rem;
	}

	.nowLogin {
		padding: 3.75rem 1.875rem 0;
		margin-bottom: 0.9375rem;
		margin-top: 4.75rem;

		>div {
			width: 100%;
			height: 2.6875rem;
			background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
			border-radius: 1.375rem;
			display: flex;
			align-items: center;
			justify-content: center;

			>p {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #0c0b0b;
			}
		}
	}

	.exchange-number {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 0.25rem;
		height: 2.6875rem;
		background: #161414;
		margin-top: 0.9375rem;

		.left-title {
			width: 10%;
			padding-left: 0.75rem;
			min-width: 5rem;
			max-width: 5rem;
			font-size: 0.8125rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
		}
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border: unset;
	}

	/deep/ .van-field__control {
		color: #ffffff !important;
	}

	.van-cell {
		background: #161414;
		//border-radius: 1.375rem;
	}

	.van-cell-group {
		background: #161414;
		border-radius: 1.375rem;
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/login.vue